module.exports = __webpack_public_path__ + "io.41316a3f458789716580.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/io.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/io.svg
// module chunks = styles